module.exports = __webpack_public_path__ + "img/hood depth.dc5331ea.png";